import React, { useEffect, useState } from "react";
import { api, fmtSDG } from "@/lib/api";
import { useApp } from "@/contexts/AppContext";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const STATUS_LABELS = {
    pending: "pending", confirmed: "confirmed", delivered: "delivered",
    on_hold: "on_hold", paid: "paid", rejected: "rejected",
};

export default function OrdersList() {
    const { t, lang } = useApp();
    const [orders, setOrders] = useState([]);
    const [tab, setTab] = useState("all");

    const load = async () => {
        const r = await api.get("/orders");
        setOrders(r.data);
    };
    useEffect(() => {
        load();
        const i = setInterval(load, 5000);
        return () => clearInterval(i);
    }, []);

    const filtered = orders.filter((o) => tab === "all" ? true : o.status === tab);

    return (
        <div className="space-y-4" data-testid="orders-list-page">
            <h1 className={`${lang === "ar" ? "font-ar" : "font-display-en italic"} text-3xl`}>{t("all_orders")}</h1>
            <Tabs value={tab} onValueChange={setTab}>
                <TabsList className="flex flex-wrap">
                    <TabsTrigger value="all" data-testid="order-filter-all">{t("all_orders")}</TabsTrigger>
                    <TabsTrigger value="pending" data-testid="order-filter-pending">{t("pending")}</TabsTrigger>
                    <TabsTrigger value="confirmed" data-testid="order-filter-confirmed">{t("confirmed")}</TabsTrigger>
                    <TabsTrigger value="paid" data-testid="order-filter-paid">{t("paid")}</TabsTrigger>
                    <TabsTrigger value="rejected" data-testid="order-filter-rejected">{t("rejected")}</TabsTrigger>
                </TabsList>
            </Tabs>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {filtered.length === 0 ? (
                    <div className="col-span-full text-center py-10 text-muted-foreground">—</div>
                ) : filtered.map((o) => (
                    <Card key={o.id} className="grain bg-card/70" data-testid={`olist-${o.id}`}>
                        <CardContent className="p-4 space-y-2">
                            <div className="flex justify-between">
                                <div className="font-medium">{t("order_no")} #{o.order_no}</div>
                                <div className="text-[10px] uppercase px-2 py-0.5 rounded-full bg-primary/15 text-primary">{t(STATUS_LABELS[o.status] || o.status)}</div>
                            </div>
                            <div className="text-xs text-muted-foreground">{t("table")} {o.table_number} · {o.waiter_name}</div>
                            <div className="text-xs text-muted-foreground">{new Date(o.created_at).toLocaleString(lang === "ar" ? "ar-SD" : "en-US")}</div>
                            <div className="flex justify-between pt-2 border-t border-border">
                                <span className="text-xs text-muted-foreground">{o.items.length} {t("items")}</span>
                                <span className="text-primary font-medium tabular-nums">{fmtSDG(o.total, lang)}</span>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </div>
        </div>
    );
}
